/* eslint-disable */
import {
  CardPaymentRedirectRequest,
  CardPaymentRedirectResponse,
} from '../models/card.payment.redirect.model';

export const mockCardPaymentRedirectResponse: CardPaymentRedirectResponse = {
  clientReferenceNumber: 'UKIWWDD3V13072000045',
  url: 'https://hpp-sandbox.worldpay.com/app/hpp/integration/wpg/corporate?OrderKey=DGIWEBUK%5EUKIWWDD3V13072000045&Ticket=00159508225446502l_oLyH_WGD2YC-QDNcU9yQ',
  orderNumber: 'UKIWWDD3V13072000045',
  status: 'PENDING',
};

export const mockCardPaymentRequest = {
  companyCode: 'D',
  schemeCode: 'T3F',
  amount: 60,
  description: 'Product Replacement',
  name: 'DEENA TREE',
  mobTel: '+447400549517',
  email: 'DEENA.PATEL@DOMESTICANDGENERAL.COM',
  address: {
    addressLine1: '31 GEORGIA ROAD',
    addressLine2: 'THORNTON HEATH',
    addressLine3: 'WARRINGTON',
    addressLine4: '',
    postalCode: 'CR7 8DU',
  },
  currency: '£',
  transactionSource: 'R',
  transactionType: 'W',
  referenceNumber: '1234',
  ipAddress: '',
  billingAddress: {
    addressLine1: 'test',
    addressLine2: 'test',
    addressLine3: 'test',
    addressLine4: 'test',
    postalCode: 'test',
    countryCode: 'test',
  },
} as CardPaymentRedirectRequest;
